import React from "react";
import { Box, Button, Divider, Stack, InputLabel, MenuItem, FormControl, Select, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import {
  selectProjectsFilterText,
  selectProjectsSortBy,
  selectProjectsSortOrder,
  setProjectsSorting,
  setProjectsFilterText,
} from "../../api/services/projects/projectsSlice";
import { useDispatch, useSelector } from "react-redux";
import CreateProjectDialog from "./CreateProjectDialog";
import ProjectAccessInfoPopup from "./ProjectAccessInfoPopup";

export default function ProjectsSortAndAddBar() {
  const dispatch = useDispatch();
  const sortOrder = useSelector(selectProjectsSortOrder);
  const sortBy = useSelector(selectProjectsSortBy);
  const sortFilterText = useSelector(selectProjectsFilterText);

  const handleChangeProjectSortBy = (event) => {
    dispatch(setProjectsSorting({ sort_by: event.target.value, sort_order: sortOrder }));
  };

  const handleChangeProjectSortOrder = (event) => {
    dispatch(setProjectsSorting({ sort_by: sortBy, sort_order: event.target.value }));
  };

  const changeProjectFilterText = (event) => {
    if (event.target.value !== undefined) {
      dispatch(setProjectsFilterText(event.target.value));
    }
  };

  return (
    <Stack direction="row" spacing={2} pb={2} alignItems="center">
      <FormControl fullWidth size="small" variant="filled" sx={{ minWidth: "160px" }}>
        <InputLabel id="sort-select-by-label">Sort By</InputLabel>
        <Select
          labelId="sort-select-by-label"
          id="sort-select-by"
          value={sortBy}
          label="Sort By"
          onChange={handleChangeProjectSortBy}
        >
          <MenuItem value={"name"}>Name</MenuItem>
          <MenuItem value={"created_date"}>Date Created</MenuItem>
          <MenuItem value={"completion_date"}>Date Completed</MenuItem>
          <MenuItem value={"status"}>Status</MenuItem>
          <MenuItem value={"project_number"}>Project Number</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth size="small" variant="filled" sx={{ minWidth: "160px" }}>
        <InputLabel id="sort-select-order-label">Sort Order</InputLabel>
        <Select
          labelId="sort-select-order-label"
          id="sort-select-order"
          value={sortOrder}
          label="Sorting Order"
          onChange={handleChangeProjectSortOrder}
        >
          <MenuItem value={"ASC"}>Ascending</MenuItem>
          <MenuItem value={"DESC"}>Descending</MenuItem>
        </Select>
      </FormControl>
      <TextField
        id="project-filter-text-field"
        name="project_filter"
        label="Filter"
        fullWidth
        variant="filled"
        size="small"
        value={sortFilterText}
        onChange={changeProjectFilterText}
      />
      <Divider orientation="vertical" variant="middle" flexItem />
      <CreateProjectDialog />
      <ProjectAccessInfoPopup />
    </Stack>
  );
}
